import styled from 'styled-components/macro';

const StyledFlexContainer = styled.div`
	display: flex;
	justify-content: ${({ justifyContent }) => justifyContent};
	align-items: ${({ alignItems }) => alignItems};
	flex-direction: ${({ flexDirection }) => flexDirection};
	gap: ${({ gapSize }) => gapSize};
`;

export default StyledFlexContainer;
